import React, { useEffect } from "react";
import Select from "react-select";
import { selectTheme } from "./../select/selectTheme.js";
import "./style.css";
import classNames from "classnames";
export default function LabeledSelect(props) {
    var _a, _b, _c, _d;
    const { slim = false } = props;
    const def = props.defaultValueIndex !== undefined ?
        props.multiple === true ?
            props.defaultValueIndex.map((i) => props.options[i])
            : props.options[props.defaultValueIndex]
        : undefined;
    useEffect(() => {
        if (props.disableChangeEventOnFirstRender === true)
            return;
        if (props.defaultValueIndex !== undefined && props.multiple === true) {
            props.onChange(def.map((i) => i === null || i === void 0 ? void 0 : i.value));
        }
        else if (props.defaultValueIndex !== undefined && def) {
            props.onChange(def.value);
        }
    }, []);
    return (React.createElement("label", { className: classNames("input-label", {
            "input-label-no-spacing": props.disableExtraSpacing,
            "input-label-slim": slim,
        }) }, (_a = props.label) !== null && _a !== void 0 ? _a : "",
        React.createElement(Select, { isMulti: (_b = props.multiple) !== null && _b !== void 0 ? _b : false, defaultValue: def, filterOption: (option, rawInput) => {
                return option.data.searchableLabel
                    .toLowerCase()
                    .includes(rawInput.toLowerCase());
            }, value: props.state === undefined ? undefined
                : props.state === null ?
                    null
                    : props.options[props.state], placeholder: (_c = props.placeholder) !== null && _c !== void 0 ? _c : "Wybierz...", noOptionsMessage: () => "Brak opcji", className: "labeled-select" +
                (props.extraWidth ? " labeled-select-extra-width"
                    : props.smaller ? " labeled-select-smaller"
                        : "") +
                (props.disableExtraSpacing ? " labeled-select-no-spacing" : ""), theme: selectTheme, classNames: {
                option: (prop) => classNames("select-option", {
                    "select-option-selected": prop.isSelected,
                    "select-option-disabled": prop.isDisabled,
                }),
                menuList: () => "select-menu-container",
                dropdownIndicator: () => "select-dropdown-indicator",
                indicatorSeparator: () => "select-indicator-separator",
                placeholder: () => "select-placeholder",
                control: (prop) => classNames({
                    "select-control-slim": slim,
                }),
            }, options: props.options.map((option) => {
                var _a;
                return ({
                    label: React.createElement("div", { className: "option-label-container" }, option.label),
                    value: option.value,
                    searchableLabel: (_a = option.searchableLabel) !== null && _a !== void 0 ? _a : (typeof option.label === "string" ? option.label : option.value),
                });
            }), isOptionDisabled: (_d = props.isOptionDisabled) !== null && _d !== void 0 ? _d : (() => false), onChange: (newValues) => {
                return (newValues &&
                    props.onChange(Array.isArray(newValues) ?
                        newValues.map((v) => v === null || v === void 0 ? void 0 : v.value)
                        : newValues === null || newValues === void 0 ? void 0 : newValues.value));
            } })));
}
